<!-- Secondary Record  查询记录状态 -->
<template>
  <div class="SecondaryRecord">
    <div class="SecondaryRecordWrap">
      <div class="SecondaryRecordTop">
        <div class="title">{{ $t("lang.SecondaryRecord") }}</div>
        <div
          class="delete"
          @click="HiddenPop">
          <i class="iconfont icon-a-closethick"></i>
        </div>
      </div>
      <div class="SecondaryRecordCenter">
        <div class="ConditionorPaging">
          <!-- 条件 -->
          <div class="Condition">
            <div class="ConditionSearch">
              <search-input
                :value="params.name"
                :placeholder="$t('lang.name')"
                :callback="searchList"
              ></search-input>
            </div>
            <div class="ConditionTime">
              <el-date-picker
                v-model="startTime"
                type="date"
                :editable="false"
                placeholder=""
                :picker-options="{ disabledDate: startTimeDisabled }"
                :clearable="false"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
              <i class="time-icon iconfont icon-cc-arrow-circle-right"></i>
              <el-date-picker
                v-model="endTime"
                type="date"
                :editable="false"
                placeholder=""
                :clearable="false"
                :picker-options="{ disabledDate: endTimeDisabled }"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
              <el-button
                type="primary"
                @click="ClickSearch">{{
                  $t("lang.filter")
                }}</el-button>
            </div>
          </div>
          <!-- 分页 -->
          <div class="Paging">
            <Pagination
              @current-change="handleCurrentChange"
              :current-page="params.pageNum"
              :pageSize="params.pageSize"
              :total="total"
              layout="prev, pageF, next, pageL, nowSize, jumper"
            />
          </div>
        </div>
        <div class="resultList">
          <el-table
            v-loading="TableLoading"
            :data="EventList"
            style="width: 100%"
          >
            <el-table-column
              prop="name"
              :label="$t('lang.name')"
              width="300"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              :label="$t('lang.startTime')"
              width="200">
              <template slot-scope="scope">
                {{ TransitionTime(scope.row.startTime) }}
              </template>
            </el-table-column>
            <el-table-column
              width="200"
              :label="$t('lang.endTime')">
              <template slot-scope="scope">
                {{ TransitionTime(scope.row.endTime) }}
              </template>
            </el-table-column>
            <el-table-column :label="$t('lang.status')">
              <template slot-scope="scope">
                <div
                  class="waitRecod"
                  v-if="scope.row.uploadStatus == 0">
                  {{ $t("lang.WaitRecod") }}
                </div>
                <div
                  class="Recoding"
                  v-else-if="
                    scope.row.uploadStatus == 10 || scope.row.uploadStatus == 11
                  "
                >
                  {{ $t("lang.Recoding") }}
                </div>
                <div
                  class="RecordSuccess"
                  v-else-if="scope.row.uploadStatus == 20"
                >
                  {{ $t("lang.RecordSuccess") }}
                </div>
                <div
                  class="RecordFailed"
                  v-else>
                  {{ $t("lang.RecordFailed") }}
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SearchInput from '@/components/common/Search'
import Pagination from '@/components/common/Pagination'
import utils from '@/assets/js/utils'
import toTips from '@/assets/js/toTipsObj'
const moment = require('moment')
export default {
  data () {
    return {
      params: {
        name: '',
        startTime: '',
        endTime: '',
        pageNum: 1,
        pageSize: 6
      },
      //   时间选择
      startTime: moment().subtract(7, 'days').format('YYYY-MM-DD'),
      endTime: moment().format('YYYY-MM-DD'),
      total: 0,
      //   事件列表
      EventList: [],
      //   加载中
      TableLoading: false
    }
  },
  components: {
    SearchInput,
    Pagination
  },
  created () {
    this.getTableList()
  },
  mounted () {},
  methods: {
    //   转换时间
    TransitionTime (time) {
      const timeObj = utils.getDateTime(new Date(time))
      if (typeof timeObj == 'object') {
        return (
          `${timeObj.month
          }/${
          timeObj.day
          }/${
          timeObj.year
          } ${
          timeObj.hour
          }:${
          timeObj.min
          }:${
          timeObj.s}`
        )
      } else {
        return ''
      }
    },
    //   隐藏弹出框
    HiddenPop () {
      this.$emit('HiddenPop', false)
    },
    // 设置开始时间不可选
    startTimeDisabled (time) {
      if (this.endTime) {
        const endTime = utils.formatTime(this.endTime, false, '-')
        return time > endTime
      } else {
        return time > new Date().getTime()
      }
    },
    // 设置结束时间不可选
    endTimeDisabled (time) {
      if (this.startTime) {
        const startTime = utils.formatTime(this.startTime, true, '-')
        let btn = false
        if (time > new Date().getTime() || time <= startTime) {
          btn = true
        } else {
          btn = false
        }
        return btn
      } else {
        return time > new Date().getTime()
      }
    },
    // 跳转的页数
    handleCurrentChange (pageNum) {
      this.params.pageNum = pageNum
      this.getTableList()
    },
    // 根据名字搜索
    searchList (name) {
      this.params.pageNum = 1
      this.params.name = name
      this.getTableList()
    },
    // 点击进行搜索
    ClickSearch () {
      this.params.pageNum = 1
      this.getTableList()
    },
    // 进行查询
    getTableList () {
      this.TableLoading = true
      this.params.startTime = utils.formatTime(this.startTime, true, '-')
      this.params.endTime = utils.formatTime(this.endTime, false, '-')
      this.axios
        .post(utils.getUrl('/event/pageEventRecord'), this.params)
        .then((res) => {
          if (res.data.errorCode === '0x0') {
            this.EventList = []
            const { result } = res.data
            this.total = result.total
            this.EventList.push(...result.list)
            this.TableLoading = false
          } else {
            const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
            this.$message.error(errorInfo)
          }
        }).catch(() => {})
    }
  }
}
</script>

<style scoped lang="less">
.SecondaryRecord {
  position: fixed;
  top: 80px;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 2000;
  background-color: rgba(102, 102, 102, 0.56);
  .SecondaryRecordWrap {
    width: 1000px;
    height: 560px;
    background: #252525;
    box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.32);
    border-radius: 6px;
    padding: 20px 0 80px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    .SecondaryRecordTop {
      padding: 0 20px 0 40px;
      height: 19px;
      font-size: 16px;
      font-weight: bold;
      color: #dfdfdf;
      line-height: 19px;
      margin-bottom: 17px;
      display: flex;
      justify-content: space-between;
      .delete {
        i {
          font-size: 15px;
          color: #dfdfdf;
        }
      }
    }
    .SecondaryRecordCenter {
      margin: 0 20px 0 24px;
      border-top: 2px solid #444444;
      padding: 21px 20px 0 16px;
      .ConditionorPaging {
        height: 36px;
        display: flex;
        justify-content: space-between;
        .Condition {
          display: flex;
          .ConditionSearch {
            ::v-deep .el-input__inner {
              width: 250px;
              height: 36px;
            }
            ::v-deep .el-icon-search {
              color: #cccccc;
            }
          }
          .ConditionTime {
            margin-left: 20px;
            ::v-deep .el-date-editor {
              width: 120px;
            }
            ::v-deep .el-input .el-input__inner {
              width: 120px;
              height: 36px;
              line-height: 36px;
              border: 1px solid #666;
              padding-right: 15px;
            }
            .time-icon {
              margin: 0 5px;
              color: #666;
              line-height: 36px;
            }
            .el-button {
              margin-left: 20px;
              padding: 10px 20px;
            }
          }
        }
      }
      .resultList {
        ::v-deep .el-table {
          tr td {
            border-bottom: 1px solid #555;
          }
        }
        ::v-deep .el-table::before {
          display: none;
        }
        .Recoding {
          color: #33ab4f;
        }
        .RecordFailed {
          color: #eb4040;
        }
      }
    }
  }
}
</style>
